import { useRef, useEffect } from 'react';
import useGame from "../stores/useGame";

export default function Escape() {

    const showDoorMessage = useGame((state) => {return state.showEscape})

    const showDoorRef = useRef()

        // Door Message on basement entry
        useEffect(() => {
            if (showDoorMessage) {
              // Apply fade-out class after 2s delay
              const timeoutId = setTimeout(() => {
                showDoorRef.current.classList.add("fade-out");
              }, 2000);
        
              // Cleanup setTimeout
              return () => {
                clearTimeout(timeoutId);
                showDoorRef.current.classList.remove("fade-out");
              };
            }
          }, [showDoorMessage]);

    return <>
        <h1 ref={showDoorRef} className='player-message'>Navigate the Abyss</h1>
    </>
}